class ProductFormOldPelletized extends Cart {
  constructor(subscriptionOptions) {
    super(product)
    this.product = product
    window.globalSubscriptionOptions = subscriptionOptions
    // this.initializeForm(product)
    console.log(product)
    console.log(subscriptionOptions)

    this.checkbox = document.querySelector("#newprice")
    this.checkbox2 = document.querySelector("#newprice2")

    if (this.checkbox) {
      this.checkbox.addEventListener("change", (event) => {
        const isChecked = event.target.checked
        if (event.target.checked) {
          // document.querySelectorAll('.pdp-weight-text').forEach(e => {
          //   e.style.display = 'none'
          // })
          this.checkbox2.checked = isChecked
          this.loadNewProduct()
        } else {
          // document.querySelectorAll('.pdp-weight-text').forEach(e => {
          //   e.style.display = 'block'
          // })
          this.checkbox2.checked = isChecked
          this.initializeFormReInit(this.product)
        }
      })
    }
    if (this.checkbox2) {
      this.checkbox2.addEventListener("change", (event) => {
        const isChecked = event.target.checked
        if (event.target.checked) {
          // document.querySelectorAll('.pdp-weight-text').forEach(e => {
          //   e.style.display = 'none'
          // })
          this.checkbox.checked = isChecked
          this.loadNewProduct2()
        } else {
          // document.querySelectorAll('.pdp-weight-text').forEach(e => {
          //   e.style.display = 'block'
          // })
          this.checkbox.checked = isChecked
          this.initializeFormReInit2(this.product)
        }
      })
    }
  }
  initializeForm(product = this.product) {
    if (typeof product.selling_plan_groups[0] !== "undefined") {
      var selling_plans = product.selling_plan_groups[0].selling_plans
      var selling_plans2 = product.selling_plan_groups
    } else {
      jQuery.getJSON(window.Shopify.routes.root + "products/" + product.handle + ".js", function (new_product) {
        var selling_plans = new_product.selling_plan_groups[0].selling_plans
        var selling_plans2 = new_product.selling_plan_groups[0]
      })
    }

    window.globalState = {
      numberOfCatsSelected: 1,
      productWeight: 20,
      remainder: 20,
      rechargeInterval: 0,
      purchaseType: "one-time-purchase",
      selectedVariantId: selected_variant.id,
      allVariants: product.variants,
      selectedBeingEditingVariantLine: null,
      sellingPlans: selling_plans,
      sellingPlans2: selling_plans2,
      count: 1,
    }

    this.oneTimePurchaseFormBlock = document.querySelector(".template-old #one-time-purchase-form-block")
    this.subscribeAndSaveFormBlock = document.querySelector(".template-old #subscribe-and-save-form-block")

    this.numberOfCatsCheckboxes = document.querySelectorAll(".template-old input[name='number-of-cats']")
    this.numberOfCatsManualCounters = document.querySelectorAll(".template-old button[name='number-of-cats-manual-counter']")
    this.numberOfCatsManualCounterValue = document.querySelector(".template-old #number-of-cats-manual-value")
    this.numberOfCatsManualCounterWrapper = document.querySelector(".template-old #number-of-cats-manual-counter-wrapper")

    this.oneTimePurchaseProductPrice = document.querySelector(".template-old #one-time-purchase-product-price")
    this.oneTimePurchaseProductWeightValue = document.querySelector(".template-old #one-time-purchase-product-weight-value")
    this.oneTimePurchaseProductWeightCounters = document.querySelectorAll(".template-old button[name='product-weight-counter']")
    this.freeSheepingBlock = document.querySelector(".template-old #free-sheeping-block")
    //window.globalSubscriptionOptions = subscriptionOptions

    this.overlay = document.getElementById("overlay")
    this.closeButton = document.querySelector(".pdp-modal__close")
    this.modal = document.querySelector(".pdp-modal")

    this.sub4Element = document.querySelector("#bag-add-to-cart-sub4")
    this.subElement = document.querySelector("#bag-add-to-cart-sub")

    this.init()
  }
  initializeFormReInit(product) {
    if (typeof product.selling_plan_groups[0] !== "undefined") {
      var selling_plans = product.selling_plan_groups[0].selling_plans
      var selling_plans2 = product.selling_plan_groups
    } else {
      jQuery.getJSON(window.Shopify.routes.root + "products/" + product.handle + ".js", function (new_product) {
        var selling_plans = new_product.selling_plan_groups[0].selling_plans
        var selling_plans2 = new_product.selling_plan_groups[0]
      })
    }

    //window.globalSubscriptionOptions = subscriptionOptions
    window.globalState.sellingPlans = selling_plans
    window.globalState.sellingPlans2 = selling_plans2
    window.globalState.allVariants = product.variants
    window.globalState.selectedVariantId = selected_variant.id

    if (window.globalState.numberOfCatsSelected == 1) {
      this.oneTimePurchaseProductWeightValue.textContent = window.globalState.numberOfCatsSelected * 10 * 2 + "lbs"
      window.globalState.productWeight = window.globalState.numberOfCatsSelected * 10 * 2
    } else if (window.globalState.numberOfCatsSelected == 3) {
      this.oneTimePurchaseProductWeightValue.textContent = "40lbs"
      window.globalState.productWeight = (window.globalState.numberOfCatsSelected + 1) * 10
    } else if (window.globalState.numberOfCatsSelected == 5) {
      this.oneTimePurchaseProductWeightValue.textContent = "60lbs"
      window.globalState.productWeight = (window.globalState.numberOfCatsSelected + 1) * 10
    } else if (window.globalState.numberOfCatsSelected == 7) {
      this.oneTimePurchaseProductWeightValue.textContent = "80lbs"
      window.globalState.productWeight = (window.globalState.numberOfCatsSelected + 1) * 10
    } else {
      this.oneTimePurchaseProductWeightValue.textContent = window.globalState.numberOfCatsSelected * 10 + "lbs"
      window.globalState.productWeight = window.globalState.numberOfCatsSelected * 10
    }

    this.renderSubAndSaveOptions()
    let cat = window.globalState.productWeight / 10
    this.showSavingsValueInfoOne(`cat_${cat}`, window.globalState.productWeight)
    this.showSavingsValue2(`cat_${cat}`, window.globalState.productWeight)
    

  }
  initializeFormReInit2(product) {
    console.log(product.title + "===" + window.globalState.selectedVariantId)

    if (typeof product.selling_plan_groups[0] !== "undefined") {
      var selling_plans = product.selling_plan_groups[0].selling_plans
      var selling_plans2 = product.selling_plan_groups
    } else {
      jQuery.getJSON(window.Shopify.routes.root + "products/" + product.handle + ".js", function (new_product) {
        var selling_plans = new_product.selling_plan_groups[0].selling_plans
        var selling_plans2 = new_product.selling_plan_groups[0]
      })
    }

    //window.globalSubscriptionOptions = subscriptionOptions
    window.globalState.sellingPlans = selling_plans
    window.globalState.sellingPlans2 = selling_plans2
    window.globalState.allVariants = product.variants

    let selectedVariantIndex = window.globalState.allVariants.findIndex((variant) => variant.title == `${window.globalState.productWeight}lbs`)
    window.globalState.selectedVariantId = window.globalState.allVariants[selectedVariantIndex].id
    this.oneTimePurchaseProductPrice.innerHTML = `${this.formatter.format(window.globalState.allVariants[selectedVariantIndex].price / 100)}`
    let cat = window.globalState.productWeight / 10
    this.showSavingsValueInfoOne(`cat_${cat}`, window.globalState.productWeight)
  }
  loadNewProduct() {
    let newProductHandle = "cat-litter-healthy-cat-copy" // handle new product
    if (product.title == "Cat Litter Healthy Cat") {
      newProductHandle = "cat-litter-healthy-cat-copy" // handle new product
    } else if (product.title == "Cat Litter Multi-Cat") {
      newProductHandle = "cat-litter-multi-cat-copy"
    } else {
      newProductHandle = "cat-litter-unscented-copy"
    }
    jQuery.getJSON(window.Shopify.routes.root + "products/" + newProductHandle + ".js", (new_product) => {
      this.initializeFormReInit(new_product)
    })
  }
  loadNewProduct2() {
    let newProductHandle = "cat-litter-healthy-cat-copy" // handle new product
    if (product.title == "Cat Litter Healthy Cat") {
      newProductHandle = "cat-litter-healthy-cat-copy" // handle new product
    } else if (product.title == "Cat Litter Multi-Cat") {
      newProductHandle = "cat-litter-multi-cat-copy"
    } else {
      newProductHandle = "cat-litter-unscented-copy"
    }

    jQuery.getJSON(window.Shopify.routes.root + "products/" + newProductHandle + ".js", (new_product) => {
      this.initializeFormReInit2(new_product)
    })
  }
  async fetchCart() {
    const response = await fetch("/cart.js")
    if (!response.ok) {
      throw new Error("Error fetching cart")
    }
    const cart = await response.json()
    return cart
  }
  checkOnlyFourMonthSubscription(cart) {
    if (cart.items.length > 0) {
      return cart.items.every((item) => item.product_type === "Cat Litter" && item.properties && item.properties._interval === 4)
    } else {
      return false
    }
  }
  updateDisplay(onlyFourMonthSubscription) {
    if (this.sub4Element && this.subElement) {
      console.log(onlyFourMonthSubscription)
      if (onlyFourMonthSubscription) {
        this.sub4Element.style.display = "flex"
        this.subElement.style.display = "none"
      } else {
        this.sub4Element.style.display = "none"
        this.subElement.style.display = "flex"
      }
    }
  }
  async manageCart() {
    try {
      const cart = await this.fetchCart()
      const onlyFourMonthSubscription = this.checkOnlyFourMonthSubscription(cart)
      this.updateDisplay(onlyFourMonthSubscription)
    } catch (error) {
      console.error("ERROR:", error)
    }
  }
  init() {
    console.log("++++++++++++++++++++++++++++++++++++++++++++++++++++++")
    const savedSubProduct = JSON.parse(localStorage.getItem("subProduct"))
    let bagAddToCart = null
    let bagAddToCartSub = null
    if (document.querySelector("#bag-add-to-cart")) {
      bagAddToCart = document.querySelector("#bag-add-to-cart")
      bagAddToCart.addEventListener("click", () => {
        this.addBag()
      })
    }
    if (document.querySelector("#bag-add-to-cart-sub")) {
      bagAddToCartSub = document.querySelector("#bag-add-to-cart-sub")
      bagAddToCartSub.addEventListener("click", () => {
        this.addSubscriptionBag()
      })
    }
    if (document.querySelector("#bag-add-to-cart-sub4")) {
      document.querySelector("#bag-add-to-cart-sub4").addEventListener("click", () => {
        this.addSubscriptionBag4()
      })
    }
    this.manageCart()
    if (savedSubProduct) {
      const { weight, interval, line } = savedSubProduct
      this.showSelectedSubscription(weight, interval, line)
      localStorage.removeItem("subProduct")
    }

    // Adding listeners to toggle between subscribe and onetime purchase options
    const purchaseTypeCheckboxes = document.querySelectorAll(".template-old input[name='purchase-type']")
    purchaseTypeCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener("click", ({ target }) => {
        if (target.id == "subscribe-and-save") {
          window.globalState.purchaseType = target.id
          this.oneTimePurchaseFormBlock.setAttribute("style", "display: none")
          this.subscribeAndSaveFormBlock.removeAttribute("style")
          if (document.querySelectorAll(".hide-block-when-one-time-purchase").length > 0) {
            document.querySelector(".hide-block-when-one-time-purchase").style.display = "block"
          }

          this.renderSubAndSaveOptions()
        }

        if (target.id == "one-time-purchase") {
          window.globalState.selectedBeingEditingVariantLine = null
          window.globalState.purchaseType = target.id
          this.subscribeAndSaveFormBlock.setAttribute("style", "display: none")
          if (document.querySelectorAll(".hide-block-when-one-time-purchase").length > 0) {
            document.querySelector(".hide-block-when-one-time-purchase").style.display = "none"
          }
          this.oneTimePurchaseFormBlock.removeAttribute("style")
          this.calculateWeightAndPrice()
        }

        this.showSavingsValue(`cat_${window.globalState.numberOfCatsSelected}`, window.globalState.productWeight)
        this.showSavingsValueInfo(`cat_${window.globalState.numberOfCatsSelected}`, window.globalState.productWeight)

        let selectedVariantIndex = window.globalState.allVariants.findIndex((variant) => variant.title == window.globalState.productWeight + "lbs")
        window.globalState.selectedVariantId = window.globalState.allVariants[selectedVariantIndex].id
      })
    })

    // adding listeners to change number of cats by selection
    this.numberOfCatsCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener("click", ({ target }) => {
        const { value } = target.dataset
        window.globalState.numberOfCatsSelected = Number(value)
        this.numberOfCatsManualCounterWrapper.classList.remove("active")
        this.calculateWeightAndPrice()

        if (window.globalState.purchaseType === "subscribe-and-save") {
          this.renderSubAndSaveOptions()
        }
      })
    })

    // adding listeners to change number of cats by counter
    this.numberOfCatsManualCounters.forEach((counter) => {
      counter.addEventListener("click", ({ target }) => {
        this.numberOfCatsManualCounterWrapper.classList.add("active")
        this.numberOfCatsCheckboxes.forEach((checkbox) => (checkbox.checked = false))

        const numberOfCatsManualDecrementor = this.numberOfCatsManualCounters[0]
        const numberOfCatsManualIncrementor = this.numberOfCatsManualCounters[1]
        const { action } = target.dataset

        if (action === "increment") {
          if (window.globalState.numberOfCatsSelected < 4) {
            window.globalState.numberOfCatsSelected = parseInt(this.numberOfCatsManualCounterValue.textContent)
          }

          window.globalState.numberOfCatsSelected += 1
          if (window.globalState.numberOfCatsSelected == 9) {
            window.globalState.numberOfCatsSelected = 8
          }
          this.numberOfCatsManualCounterValue.textContent = window.globalState.numberOfCatsSelected
          this.calculateWeightAndPrice()

          if (window.globalState.numberOfCatsSelected > 4) {
            numberOfCatsManualDecrementor.removeAttribute("disabled")
          }

          if (window.globalState.numberOfCatsSelected + 1 === 9) {
            numberOfCatsManualIncrementor.setAttribute("disabled", true)
            window.globalState.numberOfCatsSelected = 8
            const overlay = document.getElementById("overlay")
            overlay.style.display = "block"
            overlay.querySelector(".pdp-modal-form__value").focus()
          }
        }

        if (action === "decrement") {
          if (window.globalState.numberOfCatsSelected < 4) {
            window.globalState.numberOfCatsSelected = parseInt(this.numberOfCatsManualCounterValue.textContent)
          }

          window.globalState.numberOfCatsSelected -= 1
          this.numberOfCatsManualCounterValue.textContent = window.globalState.numberOfCatsSelected
          this.calculateWeightAndPrice()

          if (window.globalState.numberOfCatsSelected === 4) {
            numberOfCatsManualDecrementor.setAttribute("disabled", true)
          }

          if (window.globalState.numberOfCatsSelected < 9) {
            numberOfCatsManualIncrementor.removeAttribute("disabled")
          }
        }

        if (window.globalState.purchaseType === "subscribe-and-save") {
          this.renderSubAndSaveOptions()
        }
      })
    })

    // adding listener to change the state and target class when counter itself is clicked
    this.numberOfCatsManualCounterValue.addEventListener("click", () => {
      this.numberOfCatsManualCounterWrapper.classList.add("active")
      this.numberOfCatsCheckboxes.forEach((checkbox) => (checkbox.checked = false))

      window.globalState.numberOfCatsSelected = parseInt(this.numberOfCatsManualCounterValue.textContent)
      this.calculateWeightAndPrice()

      if (window.globalState.purchaseType === "subscribe-and-save") {
        this.renderSubAndSaveOptions()
      }
    })

    // adding listeners to change the product weight by counter
    this.oneTimePurchaseProductWeightCounters.forEach((counter) => {
      counter.addEventListener("click", ({ target }) => {
        const weightDecrementor = this.oneTimePurchaseProductWeightCounters[0]
        const weightIncrementor = this.oneTimePurchaseProductWeightCounters[1]
        const { action } = target.dataset

        if (action === "increment") {
          window.globalState.productWeight += 20
          this.oneTimePurchaseProductWeightValue.textContent = window.globalState.productWeight + "lbs"
          let cat = window.globalState.productWeight / 10
          this.showSavingsValueInfoOne(`cat_${cat}`, window.globalState.productWeight)
          if (window.globalState.productWeight > 20) {
            weightDecrementor.removeAttribute("disabled")
          }

          if (window.globalState.productWeight + 20 > 80) {
            weightIncrementor.setAttribute("disabled", true)
          }
        }

        if (action === "decrement") {
          console.log("decrement")

          if (window.globalState.productWeight - 20 === 0) return

          window.globalState.productWeight -= 20

          this.oneTimePurchaseProductWeightValue.textContent = window.globalState.productWeight + "lbs"

          let cat = window.globalState.productWeight / 10
          this.showSavingsValueInfoOne(`cat_${cat}`, window.globalState.productWeight)
          if (window.globalState.productWeight === 20) {
            weightDecrementor.setAttribute("disabled", true)
          }

          if (window.globalState.productWeight < 80) {
            weightIncrementor.removeAttribute("disabled")
          }
        }

        let selectedVariantIndex

        if (window.globalState.productWeight === 20 && window.globalState.purchaseType === "one-time-purchase") {
          this.freeSheepingBlock.setAttribute("style", "display: none")
          selectedVariantIndex = window.globalState.allVariants.findIndex((variant) => variant.title == "10lbs")
          this.addFreeShippingText(selectedVariantIndex)
        }

        if (window.globalState.productWeight > 20 && window.globalState.purchaseType === "one-time-purchase") {
          console.log("fff")
          selectedVariantIndex = window.globalState.allVariants.findIndex((variant) => variant.title == `${window.globalState.productWeight}lbs`)

          this.oneTimePurchaseProductPrice.innerHTML = `${this.formatter.format(window.globalState.allVariants[selectedVariantIndex].price / 100)}`
        }

        if (window.globalState.purchaseType === "subscribe-and-save") {
          selectedVariantIndex = window.globalState.allVariants.findIndex((variant) => variant.title == window.globalState.productWeight + "lbs")
          this.oneTimePurchaseProductPrice.textContent = this.formatter.format(window.globalState.allVariants[selectedVariantIndex].price / 100)
        }

        window.globalState.selectedVariantId = window.globalState.allVariants[selectedVariantIndex].id
      })
    })

    const oneTimePurchaseAddToCartButton = document.querySelector(".template-old #one-time-purchase-add-to-cart")
    oneTimePurchaseAddToCartButton.addEventListener("click", () => this.addOneTimePurchaseProductToCart())

    const subscribeAndSaveAddtoCart = document.querySelector(".template-old #subscribe-and-save-add-to-cart")

    subscribeAndSaveAddtoCart.addEventListener("click", () => this.addSubscriptionProductToCart())
    purchaseTypeCheckboxes[0].click()

    const modalAddtoCart = document.querySelector(".pdp-modal-form__btn")
    const modalInput = document.querySelector(".pdp-modal-form__value")

    modalAddtoCart.addEventListener("click", () => {
      window.globalState.numberOfCatsSelected = modalInput.value
      this.calculateWeightAndPrice()
      this.addSubscriptionProductToCart2()
      window.globalState.numberOfCatsSelected = 8
      this.numberOfCatsManualCounterValue.textContent = window.globalState.numberOfCatsSelected
      this.overlay.style.display = "none"
    })

    this.closeButton.addEventListener(
      "click",
      function () {
        this.hideOverlay()
      }.bind(this)
    )
  }

  hideOverlay() {
    window.globalState.numberOfCatsSelected = 8
    this.numberOfCatsManualCounterValue.textContent = window.globalState.numberOfCatsSelected
    this.overlay.style.display = "none"
  }
  async addOneTimePurchaseProductToCart() {
    console.log("addOneTimePurchaseProductToCart")
    const formData = {
      items: [
        {
          id: window.globalState.selectedVariantId,
          quantity: 1,
          properties: {
            _subscribe: "not_subscribed",
          },
        },
      ],
    }

    const cartItems = await this.getItems()
    const itemIndex = cartItems.items.findIndex((item) => item.id == window.globalState.selectedVariantId)

    if (itemIndex < 0) {
      this.addItem(formData).then((res) => {
        this.toggleCart()
        console.log("addSubscriptionProductToCart")
      })
    } else {
      console.log("addSubscriptionProductToCart itemIndex > 0")
      this.toggleCart()
    }
  }
  async addSubscriptionProductToCart() {
    let canAdd = true

    // this.overlayLoading()

    const cartItems = await this.getItems()

    const filteredVariants = cartItems.items.filter((item) => item.id == window.globalState.selectedVariantId)
    filteredVariants.forEach((item) => {
      if (item.properties._interval == window.globalState.rechargeInterval) {
        canAdd = false
      }
    })

    if (!canAdd) {
      this.toggleCart()
      return
    }

    let sellingPlanId = ""

    console.log('------------');
    console.log(window.globalState.rechargeInterval);

    window.globalState.sellingPlans2.forEach((sellingPlan) => {
      console.log(sellingPlan)
      if (window.globalState.rechargeInterval == 45) {

        sellingPlanId = 2325053589

      } else if (sellingPlan.name.includes(window.globalState.rechargeInterval)) {
        sellingPlanId = sellingPlan.selling_plans[0].id
      }
    })
    console.log(window.globalState.selectedVariantId)
    const formData = {
      id: window.globalState.selectedVariantId,
      quantity: 1,
      selling_plan: sellingPlanId,
      properties: {
        _interval: window.globalState.rechargeInterval,
        _subscribe: "subscribed",
      },
    }

    if (window.globalState.selectedBeingEditingVariantLine) {
      this.changeItem({ line: Number(window.globalState.selectedBeingEditingVariantLine), quantity: 0 }).then(async () => {
        window.globalState.selectedBeingEditingVariantLine = null
        this.addItem(formData).then((res) => this.toggleCart())
      })
    } else {
      await this.addItem(formData).then((res) => {
        this.toggleCart()

        console.log("addSubscriptionProductToCart")
        console.log(res)
      })
    }

    const subscribeAndSaveAddtoCart = document.querySelector(".template-old #subscribe-and-save-add-to-cart")
    subscribeAndSaveAddtoCart.textContent = "Add To Cart"
  }
  async addSubscriptionBag() {
    console.log("subscr")
    let canAdd = true

    // this.overlayLoading()

    const cartItems = await this.getItems()

    var hasCatLitter = cartItems.items.some((item) => item.product_type === "Cat Litter" && Boolean(item.properties?._interval))

    if (!hasCatLitter) {
      document.getElementById("overlay2").style.display = "block"
      return
    }

    const filteredVariants = cartItems.items.filter((item) => item.id == window.globalState.selectedVariantId)
    filteredVariants.forEach((item) => {
      if (item.properties._interval == window.globalState.rechargeInterval) {
        canAdd = false
      }
    })

    if (!canAdd) {
      this.toggleCart()
      return
    }

    let sellingPlanId = ""
    window.globalState.sellingPlans.forEach((sellingPlan) => {
      sellingPlanId = sellingPlan.id
    })
    console.log(sellingPlanId)
    const formData = {
      id: window.globalState.selectedVariantId,
      quantity: 1,
      selling_plan: sellingPlanId,
      properties: {
        _interval: window.globalState.rechargeInterval,
        _subscribe: "subscribed",
      },
    }

    if (window.globalState.selectedBeingEditingVariantLine) {
      this.changeItem({ line: Number(window.globalState.selectedBeingEditingVariantLine), quantity: 0 }).then(async () => {
        window.globalState.selectedBeingEditingVariantLine = null
        this.addItem(formData).then((res) => this.toggleCart())
      })
    } else {
      await this.addItem(formData).then((res) => {
        this.toggleCart()
        console.log(res)
      })
    }

    const subscribeAndSaveAddtoCart = document.querySelector(".template-old #subscribe-and-save-add-to-cart")
    subscribeAndSaveAddtoCart.textContent = "Add To Cart"
  }
  async addSubscriptionBag4() {
    console.log("subscr4")
    let canAdd = true

    // this.overlayLoading()

    const cartItems = await this.getItems()

    var hasCatLitter = cartItems.items.some((item) => item.product_type === "Cat Litter" && Boolean(item.properties?._interval))

    if (!hasCatLitter) {
      document.getElementById("overlay2").style.display = "block"
      return
    }

    const filteredVariants = cartItems.items.filter((item) => item.id == window.globalState.selectedVariantId)
    filteredVariants.forEach((item) => {
      if (item.properties._interval == window.globalState.rechargeInterval) {
        canAdd = false
      }
    })

    if (!canAdd) {
      this.toggleCart()
      return
    }

    let sellingPlanId = ""
    window.globalState.sellingPlans.forEach((sellingPlan) => {
      sellingPlanId = sellingPlan.id
    })
    console.log(sellingPlanId)
    const formData = {
      id: 45065132540053, //id 120 bag
      quantity: 1,
      selling_plan: 2308898965, //id selling plan for 4 month
      properties: {
        _interval: window.globalState.rechargeInterval,
        _subscribe: "subscribed",
      },
    }

    if (window.globalState.selectedBeingEditingVariantLine) {
      this.changeItem({ line: Number(window.globalState.selectedBeingEditingVariantLine), quantity: 0 }).then(async () => {
        window.globalState.selectedBeingEditingVariantLine = null
        this.addItem(formData).then((res) => this.toggleCart())
      })
    } else {
      await this.addItem(formData).then((res) => {
        this.toggleCart()
        console.log(res)
      })
    }

    const subscribeAndSaveAddtoCart = document.querySelector(".template-old #subscribe-and-save-add-to-cart")
    subscribeAndSaveAddtoCart.textContent = "Add To Cart"
  }
  async addBag() {
    const cartItems = await this.getItems()

    var hasCatLitter = cartItems.items.some((item) => item.product_type === "Cat Litter")

    if (!hasCatLitter) {
      document.getElementById("overlay").style.display = "block"
      return
    }
    const formData = {
      items: [
        {
          id: window.globalState.selectedVariantId,
          quantity: 1,
          properties: {
            _subscribe: "not_subscribed",
          },
        },
      ],
    }

    const itemIndex = cartItems.items.findIndex((item) => item.id == window.globalState.selectedVariantId)
    this.addItem(formData).then((res) => {
      this.toggleCart()
      console.log("addOneTimeBag")
    })
    // if (itemIndex < 0) {
    //   this.addItem(formData).then((res) => {
    //     this.toggleCart()
    //     console.log('addOneTimeBag')
    //   })
    // } else {

    //   console.log('addOneTimeBag itemIndex > 0')
    //   this.toggleCart()
    // }
  }
  async addSubscriptionProductToCart2() {
    let canAdd = true

    const cartItems = await this.getItems()

    let sellingPlanId = ""
    window.globalState.sellingPlans.forEach((sellingPlan) => {
      if (sellingPlan.name.includes(window.globalState.rechargeInterval)) {
        sellingPlanId = sellingPlan.id
      }
    })

    const formData = {
      id: window.globalState.selectedVariantId,
      quantity: window.globalState.count,
      selling_plan: sellingPlanId,
      properties: {
        _interval: window.globalState.rechargeInterval,
        _subscribe: "subscribed",
      },
    }

    if (window.globalState.selectedBeingEditingVariantLine) {
      this.changeItem({ line: Number(window.globalState.selectedBeingEditingVariantLine), quantity: 0 }).then(async () => {
        window.globalState.selectedBeingEditingVariantLine = null
        this.addItem(formData).then((res) => this.toggleCart())
      })
    } else {
      await this.addItem(formData).then((res) => {
        console.log("addSubscriptionProductToCart2")
        console.log(res)
      })
    }

    const subscribeAndSaveAddtoCart = document.querySelector(".template-old #subscribe-and-save-add-to-cart")
    subscribeAndSaveAddtoCart.textContent = "Add To Cart"

    let selectedVariantIndex
    window.globalState.productWeight = window.globalState.remainder
    selectedVariantIndex = window.globalState.allVariants.findIndex((variant) => variant.title == window.globalState.productWeight + "lbs")
    const oneTimePurchaseIndex = window.globalState.allVariants.findIndex((variant) => variant.title == `${window.globalState.productWeight}lbs`)

    this.oneTimePurchaseProductPrice.textContent = this.formatter.format(window.globalState.allVariants[oneTimePurchaseIndex].price / 100)

    window.globalState.selectedVariantId = window.globalState.allVariants[selectedVariantIndex].id

    await this.addSubscriptionProductToCart()
  }

  calculateWeightAndPrice() {
    const weightDecrementor = this.oneTimePurchaseProductWeightCounters[0]

    if (window.globalState.numberOfCatsSelected == 1) {
      this.oneTimePurchaseProductWeightValue.textContent = window.globalState.numberOfCatsSelected * 10 * 2 + "lbs"
      window.globalState.productWeight = window.globalState.numberOfCatsSelected * 10 * 2
    } else if (window.globalState.numberOfCatsSelected == 3) {
      this.oneTimePurchaseProductWeightValue.textContent = "40lbs"
      window.globalState.productWeight = (window.globalState.numberOfCatsSelected + 1) * 10
    } else if (window.globalState.numberOfCatsSelected == 5) {
      this.oneTimePurchaseProductWeightValue.textContent = "60lbs"
      window.globalState.productWeight = (window.globalState.numberOfCatsSelected + 1) * 10
    } else if (window.globalState.numberOfCatsSelected == 7) {
      this.oneTimePurchaseProductWeightValue.textContent = "80lbs"
      window.globalState.productWeight = (window.globalState.numberOfCatsSelected + 1) * 10
    } else {
      this.oneTimePurchaseProductWeightValue.textContent = window.globalState.numberOfCatsSelected * 10 + "lbs"
      window.globalState.productWeight = window.globalState.numberOfCatsSelected * 10
    }

    if (window.globalState.productWeight > 20) {
      weightDecrementor.removeAttribute("disabled")
    }

    if (window.globalState.productWeight == 20) {
      weightDecrementor.setAttribute("disabled", true)
    }

    let selectedVariantIndex

    if (window.globalState.numberOfCatsSelected === 1 && window.globalState.purchaseType === "one-time-purchase") {
      selectedVariantIndex = window.globalState.allVariants.findIndex((variant) => variant.title == "20lbs")
      this.freeSheepingBlock.setAttribute("style", "display: none")
      this.addFreeShippingText(selectedVariantIndex)
      this.showSavingsValue(`cat_${window.globalState.numberOfCatsSelected}`, window.globalState.productWeight)
      this.showSavingsValueInfo(`cat_${window.globalState.numberOfCatsSelected}`, window.globalState.productWeight)
      this.showSavingsValueInfoOne(`cat_${window.globalState.numberOfCatsSelected}`, window.globalState.productWeight)
    }

    if (window.globalState.numberOfCatsSelected > 1 && window.globalState.purchaseType === "one-time-purchase") {
      selectedVariantIndex = window.globalState.allVariants.findIndex((variant) => variant.title == `${window.globalState.productWeight}lbs`)

      this.oneTimePurchaseProductPrice.innerHTML = `
                  ${this.formatter.format(window.globalState.allVariants[selectedVariantIndex].price / 100)}
              `
      this.showSavingsValue(`cat_${window.globalState.numberOfCatsSelected}`, window.globalState.productWeight)
      this.showSavingsValueInfoOne(`cat_${window.globalState.numberOfCatsSelected}`, window.globalState.productWeight)
    }

    if (window.globalState.purchaseType === "subscribe-and-save") {
      if (window.globalState.productWeight == 30) {
        window.globalState.productWeight = 40
      } else if (window.globalState.productWeight == 50) {
        window.globalState.productWeight = 60
      } else if (window.globalState.productWeight == 70) {
        window.globalState.productWeight = 80
      }

      if (window.globalState.productWeight > 80) {
        window.globalState.count = Math.floor(window.globalState.productWeight / 80)
        window.globalState.remainder = window.globalState.productWeight % 80
        window.globalState.productWeight = 80
        selectedVariantIndex = window.globalState.allVariants.findIndex((variant) => variant.title == window.globalState.productWeight + "lbs")
        const oneTimePurchaseIndex = window.globalState.allVariants.findIndex((variant) => variant.title == `${window.globalState.productWeight}lbs`)

        this.oneTimePurchaseProductPrice.textContent = this.formatter.format(window.globalState.allVariants[oneTimePurchaseIndex].price / 100)

        window.globalState.selectedVariantId = window.globalState.allVariants[selectedVariantIndex].id
        return
      } else {
        selectedVariantIndex = window.globalState.allVariants.findIndex((variant) => variant.title == window.globalState.productWeight + "lbs")
        const oneTimePurchaseIndex = window.globalState.allVariants.findIndex((variant) => variant.title == `${window.globalState.productWeight}lbs`)

        this.oneTimePurchaseProductPrice.textContent = this.formatter.format(window.globalState.allVariants[oneTimePurchaseIndex].price / 100)
      }
    }

    window.globalState.selectedVariantId = window.globalState.allVariants[selectedVariantIndex].id
  }

  changeSubAndSaveOption(interval, weight, cat) {

    window.globalState.rechargeInterval = interval
    window.globalState.productWeight = weight

    const selectedVariantIndex = window.globalState.allVariants.findIndex((variant) => variant.title == window.globalState.productWeight + "lbs")

    window.globalState.selectedVariantId = window.globalState.allVariants[selectedVariantIndex].id

    this.showSavingsValue(cat, weight)
    this.showSavingsValueInfo(cat, weight)

    console.log('interval');
    console.log(interval);
  }

  renderSubAndSaveOptionTemplate(cat, selectByDefault) {
    let html = ``

    console.log('render');
    console.log(cat);

    for (let index in window.globalSubscriptionOptions[cat]) {
      const option = window.globalSubscriptionOptions[cat][index]
      const reversedIndex = Number(index) - window.globalSubscriptionOptions[cat].length

      let selectedVariantIndex = window.globalState.allVariants.findIndex((variant) => variant.title == option.weight + "lbs");
      let selectedVariant = window.globalState.allVariants[selectedVariantIndex];

      console.log(window.globalSubscriptionOptions);
      console.log(option.weight + 'lbs');
      console.log(selectedVariantIndex);

      if (selectedVariantIndex == -1) {
        continue;
      }

      let selectedVariantPriceAfterDiscount = (selectedVariant.price - selectedVariant.price * 0.18) / 100

      if (Number(index) + 1 === selectByDefault || reversedIndex === selectByDefault) {
        window.globalState.rechargeInterval = option.interval
        window.globalState.productWeight = option.weight
        window.globalState.selectedVariantId = selectedVariant.id
      }

      html += `
        
                <li class="options__item sss">
                  <input 
                      data-interval="${option.interval}"
                      data-weight="${option.weight}"
                      data-cat="${cat}"
                      class="options_selector"  
                      name="sub-options" 
                      id="sub-option-${option.weight}" 
                      type="radio" 
                      value="${option.interval}"
                      hidden
                      ${Number(index) + 1 === selectByDefault ? "checked" : ""}
                      ${reversedIndex === selectByDefault ? "checked" : ""}
                  />
                  <label class="label--simple full" for="sub-option-${option.weight}">
                      ${
                        option.eco
                          ? `
                          <div class="eco-box eco-updated">
                              <div class="tooltip">
                                  <img src="${ecoImg}" alt="" />
                                  <div class="text__updated">
                                      Fewer shipments = a lower carbon footprint.
                                  </div>
                                  <div class="square"></div>
                              </div>
                              <span class="eco-label">Eco</span>
                              <span class="eco-label-updated"> <img src="${ecoUpdateImg}" alt="" /></span>
                          </div>
                      `
                          : ""
                      }
                      <div class="weight">
                        <span class="heading">${option.weight}lbs</span>
                        Every ${option.interval === 1 ? "" : option.interval === 45 ? "1.5" : option.interval} ${option.interval === 45 ? "months" : `Month${option.interval > 1 ? "s" : ""}`}
                      </div>
                      <div class="price">
                          <span class="paragraph">
                          ${option.weight === 40 && option.interval === 45 ? "$32.66/Month" : option.interval === 45 ? "$18.66/Month" : `${this.formatter.format(selectedVariantPriceAfterDiscount / option.interval)}/month`}
                          
                          </span>
                          <span class="heading">
                              ${this.formatter.format(selectedVariantPriceAfterDiscount)}
                          </span>
                      </div>
                  </label>
                </li>   
              `
    }

    const subscribeAndSaveOptionsWrapper = document.querySelector(".template-old #subscribe-and-save-options")
    subscribeAndSaveOptionsWrapper.innerHTML = html;

    // Attach event listener
    let inputItems = subscribeAndSaveOptionsWrapper.querySelectorAll('.options__item input');
    for (let i = 0; i < inputItems.length; i ++) {
      inputItems[i].addEventListener('change', function (e) {
        if (e.currentTarget.checked == true) {
          productFormOld.changeSubAndSaveOption(parseInt(e.currentTarget.dataset.interval), parseInt(e.currentTarget.dataset.weight), e.currentTarget.dataset.cart);
        }
      });
    }

    this.showSavingsValue(cat, window.globalState.productWeight)
    console.log('hhh');
    this.showSavingsValueInfo(cat, window.globalState.productWeight)
  }

  renderSubAndSaveOptions() {
    console.log(window.globalState.numberOfCatsSelected)
    if (window.globalState.numberOfCatsSelected == 3) {
      this.renderSubAndSaveOptionTemplate(`cat_${window.globalState.numberOfCatsSelected}`, 1)
    } else {
      this.renderSubAndSaveOptionTemplate(`cat_${window.globalState.numberOfCatsSelected}`, -1)
    }
  }

  showSelectedSubscription(weight, interval, line) {
    const subscribeAndSaveAddtoCart = document.querySelector(".template-old #subscribe-and-save-add-to-cart")
    subscribeAndSaveAddtoCart.textContent = "Update Cart"

    const cartWrapper = document.querySelector(".template-old .ajax-cart__wrapper")
    cartWrapper.classList.remove("open")
    document.body.removeAttribute("style")

    window.globalState.selectedBeingEditingVariantLine = line
    window.globalState.purchaseType = "subscribe-and-save"
    window.globalState.productWeight = parseInt(weight)

    const purchaseTypeCheckboxes = document.querySelectorAll(".template-old input[name='purchase-type']")
    purchaseTypeCheckboxes[0].checked = true

    this.oneTimePurchaseFormBlock.setAttribute("style", "display: block")

    this.subscribeAndSaveFormBlock.removeAttribute("style")

    for (let cat in window.globalSubscriptionOptions) {
      window.globalSubscriptionOptions[cat].forEach((element, index) => {
        if (element.weight === parseInt(weight) && element.interval === Number(interval)) {
          this.renderSubAndSaveOptionTemplate(cat, Number(index) + 1)

          window.globalState.numberOfCatsSelected = Number(cat.split("_")[1])

          if (window.globalState.numberOfCatsSelected <= 3) {
            this.numberOfCatsCheckboxes.forEach((checkbox) => {
              const { value } = checkbox.dataset

              if (Number(value) === window.globalState.numberOfCatsSelected) {
                checkbox.checked = true
              }
            })
          } else {
            const numberOfCatsManualDecrementor = this.numberOfCatsManualCounters[0]
            const numberOfCatsManualIncrementor = this.numberOfCatsManualCounters[1]

            this.numberOfCatsManualCounterWrapper.classList.add("active")
            this.numberOfCatsCheckboxes.forEach((checkbox) => (checkbox.checked = false))
            this.numberOfCatsManualCounterValue.textContent = window.globalState.numberOfCatsSelected

            if (window.globalState.numberOfCatsSelected > 4) {
              numberOfCatsManualDecrementor.removeAttribute("disabled")
            }

            if (window.globalState.numberOfCatsSelected + 1 === 9) {
              numberOfCatsManualIncrementor.setAttribute("disabled", true)
            }
          }
        }
      })
    }
  }

  showSavingsValue(cat, weight = null) {
    const savingsMapping = {
      cat_1: {
        10: "18%",
        20: "50%",
        40: "57%",
      },
      cat_2: {
        20: "18%",
        40: "29%",
      },
      cat_3: {
        30: "18%",
        60: "23%",
      },
      cat_4: {
        40: "27%",
      },
      cat_5: {
        50: "27%",
      },
      cat_6: {
        60: "27%",
      },
      cat_7: {
        70: "27%",
      },
      cat_8: {
        80: "27%",
      },
    }

    const savingValue = savingsMapping[cat] && savingsMapping[cat][weight]
    const highestSavingValue = savingsMapping[cat] && savingsMapping[cat][Object.keys(savingsMapping[cat])[Object.keys(savingsMapping[cat]).length - 1]]

    if (savingValue) {
      this.setSavingValues("", savingValue, highestSavingValue)
    }
    
  }

  setSavingValues(dollar, percentage, highestSavingValue) {
    const dollarSavings = document.querySelector(".template-old #dollars_saving")
    dollarSavings.textContent = dollar

    const percantageSavings = document.querySelector(".template-old #percantage_saving")
    // if (this.checkbox || this.checkbox2) {
    //   if (this.checkbox.checked || this.checkbox2.checked) {
    //     percantageSavings.textContent = '18%'
    //   } else {
    //     percantageSavings.textContent = percentage
    //   }
    // } else {

    // }
    percantageSavings.textContent = percentage

    const percentageSavingsOneTime = document.querySelector(".template-old #percantage_saving_onetime")
    percentageSavingsOneTime.textContent = highestSavingValue
  }

  showSavingsValueInfo(cat, weight = null) {
    const savingsMapping = {
      cat_1: {
        10: "1x10lbs pack",
        20: "1x20lbs pack",
        40: "2x20lbs packs",
      },
      cat_2: {
        20: "1x20lbs pack",
        40: "2x20lbs packs",
      },
      cat_3: {
        30: "1x20lbs, 1x10lbs packs",
        60: "3x20lbs packs",
      },
      cat_4: {
        40: "2x20lbs packs",
      },
      cat_5: {
        50: "2x20, 1x10lbs packs",
      },
      cat_6: {
        60: "3x20lbs packs",
      },
      cat_7: {
        70: "3x20, 1x10lbs packs",
      },
      cat_8: {
        80: "4x20lbs packs",
      },
    }

    const savingValue = savingsMapping[cat] && savingsMapping[cat][weight]

    if (savingValue) {
      this.setSavingValuesInfo(weight, savingValue)
    }
  }
  setSavingValuesInfo(weight, value) {
    if (document.querySelector(".template-old .pdp-weight-block__weight-js") && document.querySelector(".template-old .pdp-weight-block__value")) {
      const percantageSavings = document.querySelector(".template-old .pdp-weight-block__weight-js")
      percantageSavings.textContent = weight

      const percentageSavingsOneTime = document.querySelector(".template-old .pdp-weight-block__value")
      percentageSavingsOneTime.textContent = value
    }
  }
  showSavingsValueInfoOne(cat, weight = null) {
    const savingsMapping = {
      cat_1: {
        10: "1x10lbs bag",
        20: "1x20lbs bag",
        40: "2x20lbs bags",
      },
      cat_2: {
        20: "1x20lbs bag",
        40: "2x20lbs bags",
      },
      cat_3: {
        30: "1x20lbs, 1x10lbs bags",
        60: "3x20lbs bags",
      },
      cat_4: {
        40: "2x20lbs bags",
      },
      cat_5: {
        50: "2x20, 1x10lbs bags",
      },
      cat_6: {
        60: "3x20lbs bags",
      },
      cat_7: {
        70: "3x20, 1x10lbs bags",
      },
      cat_8: {
        80: "4x20lbs bags",
      },
    }
    const savingsMapping2 = {
      cat_1: {
        10: "1x10lbs bag",
        20: "2x10lbs bags",
        40: "3x10lbs bags",
      },
      cat_2: {
        20: "2x10lbs bags",
        40: "4x10lbs bags",
      },
      cat_3: {
        30: "3x10lbs bags",
        60: "6x10lbs bags",
      },
      cat_4: {
        40: "4x10lbs bags",
      },
      cat_5: {
        50: "5x10lbs bags",
      },
      cat_6: {
        60: "6x10lbs bags",
      },
      cat_7: {
        70: "7x10lbs bags",
      },
      cat_8: {
        80: "8x10lbs bags",
      },
    }
    let savingValue 

    if (this.checkbox2) {
      savingValue = savingsMapping[cat] && savingsMapping[cat][weight]
      if (this.checkbox2.checked) {
        console.log('checked');
        savingValue = savingsMapping2[cat] && savingsMapping2[cat][weight]
      } else {
        console.log('NOchecked');
        savingValue = savingsMapping[cat] && savingsMapping[cat][weight]
      }
    } else {
      savingValue = savingsMapping[cat] && savingsMapping[cat][weight]
    }
    

    if (savingValue) {
      this.setSavingValuesInfoOne(weight, savingValue)
    }
  }

  setSavingValuesInfoOne(weight, value) {

    if (document.querySelector(".template-old .pdp-weight-block__weight-js") && document.querySelector(".template-old .pdp-weight-block__value")) {
      const percantageSavings = document.querySelector(".template-old .pdp-weight-block__weight-js--one")
      percantageSavings.textContent = weight

      const percentageSavingsOneTime = document.querySelector(".template-old .pdp-weight-block__value--one")
      percentageSavingsOneTime.textContent = value
    }
  }

  addFreeShippingText(selectedVariantIndex) {
    const text = `
              <span>${this.formatter.format(window.globalState.allVariants[selectedVariantIndex].price / 100)}</span>
              
          `
    this.oneTimePurchaseProductPrice.innerHTML = text
  }
}